export default {
  computed: {
    currentBuilding:     ({$store, currentBuildingId}) => $store.getters['area/buildingFind'](currentBuildingId),
    currentBuildingId:   ({$store}) => $store.state.current.buildingId,
    svgElm() {
      return this.$store.state.map.svgElm;
    },
    baseDomRect: ({$store}) => $store.state.map.baseDomRect,
    pxToSvgSize() {
      return (value) => {
        let ratio = 1;

        if (this.$store.state.map.getFitOrientation  == 'height') {
          ratio = this.currentBuilding.depth / this.baseDomRect.height;
        } else {
          ratio = this.currentBuilding.width / this.baseDomRect.width;
        };

        if (ratio === Infinity) ratio = 0;

        return ratio * value;
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/map.js